import { MouseEventHandler } from 'react';

import { Icon } from 'components/Icon';

import {
  CmsTileModalCloseButtonStyled,
  CmsTileModalCloseButtonText,
} from './CmsTileModalCloseButton.styled';

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export function CmsTileModalCloseButton({ onClick }: Props) {
  return (
    <CmsTileModalCloseButtonStyled
      type="button"
      data-qa-id="cms-tg-close-button"
      onClick={onClick}
    >
      <CmsTileModalCloseButtonText>
        {getText('close')}
      </CmsTileModalCloseButtonText>

      <Icon initialColorName="battleshipGrey" name="close" size={24} />
    </CmsTileModalCloseButtonStyled>
  );
}
